<template>
  <div>
    <h1 class="text-3xl mb-4">Nouveau service</h1>

    <form
      @submit.prevent="submit"
      class="clearfix"
    >
      <input
        v-model="slug"
        placeholder="slug"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <input
        v-model="name"
        placeholder="nom"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <!-- error message -->
      <Error
        v-if="error"
        v-bind="error"
      />

      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white shadow float-right"
      >
        Ajouter service
      </button>
    </form>
  </div>
</template>

<script>
import Error from '@/components/Error'

export default {
  components: {
    Error
  },

  data() {
    return {
      slug: null,
      name: null,
      error: null
    }
  },

  methods: {
    async submit() {
      const params = {
        service: {
          slug: this.slug,
          name: this.name
        }
      }

      try {
        await this.$axios.post('/services', params)

        this.error = null

        this.$router.push('/services')
      } catch (err) {
        this.error = err.response.data
      }
    }
  }
}
</script>
